import { IMuiSelectOption } from "../../components/framework/muiAutocomplete2";
import { DayBookingUsageType } from "../common/enums";
import { DayBookingItemBeta } from "../dayBooking/dayBookingItemBeta";
import { DayBookingTypeItemBeta } from "../dayBookingType/dayBookingTypeItemBeta";
import { IWorkHoursItem } from "./workHoursItem";

export interface DayBookingListRow {
    id?: string;
    workShiftId?: string;
    workShiftTimeSlotId?: string;
    dayBookingTypeId?: string;
    costCenterId?: string;
    costCenterName?: string;
    vehicleId?: string;
    vehicleName?: string;
    day: string;
    endDay: string;
    amount: number;
    dayUsageType?: DayBookingUsageType;
    comment?: string;
    state?: number;
    isAutomatic: boolean;
}

export const dayBookingToListRow = ({
    id,
    dayBookingTypeId,
    costCenterId,
    costCenterName,
    vehicleId,
    vehicleName,
    day,
    endDay,
    amount,
    dayUsageType,
    state,
    comment,
}: DayBookingItemBeta) =>
    ({
        id,
        dayBookingTypeId,
        costCenterId,
        costCenterName,
        vehicleId,
        vehicleName,
        day,
        endDay,
        amount,
        dayUsageType,
        state,
        comment,
        isAutomatic: false,
    } as DayBookingListRow);

export const workHourToListRow = (
    {
        workShiftId,
        workShiftTimeSlotId,
        category,
        costCenterId,
        vehicleId,
        dateStr,
        amount,
        salaryRowTypeId,
    }: IWorkHoursItem,
    costCenters: IMuiSelectOption[],
    vehicles: IMuiSelectOption[],
    dayBookingTypes: DayBookingTypeItemBeta[]
) =>
    ({
        id: `${workShiftId}.${category}`,
        workShiftTimeSlotId,
        day: dateStr,
        endDay: dateStr,
        amount,
        dayUsageType: DayBookingUsageType.NotFullDay,
        costCenterId,
        costCenterName: costCenters?.find((c) => c.value === costCenterId)
            ?.label,
        vehicleId,
        vehicleName: vehicles?.find((v) => v.value === vehicleId)?.label,
        dayBookingTypeId: dayBookingTypes?.find(
            (t) => t.salaryRowTypeId === salaryRowTypeId
        )?.id,
        isAutomatic: true,
    } as DayBookingListRow);
